import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  change({ target }) {
    const display = target.value === 'true' ? 'flex' : 'none';
    this.#changeDisplay(display);
  }

  #changeDisplay(display) {
    for (const element of this.element.querySelectorAll('.addresses_area')) {
      element.style.display = display;
    }
  }
}
